import { WebshopPackage } from '../../../schema/webshop-package'
import type { CartStoreType } from '../../reducers/cart/cart'
import { State } from '../../reducers'

export const selectCart = (state: State): CartStoreType => state.cart
export const selectCartPackages = (state: State): Array<WebshopPackage> => state.cart.packages
